import { DatasourceCanBaseIcon } from '@tableau/icons/DatasourceCanBaseIcon';
import { DatasourceCanEmbeddedIcon } from '@tableau/icons/DatasourceCanEmbeddedIcon';
import { DatasourceCanExtractEmbeddedIcon } from '@tableau/icons/DatasourceCanExtractEmbeddedIcon';
import { DatasourceCanExtractIcon } from '@tableau/icons/DatasourceCanExtractIcon';
import { Colors } from '@tableau/icons/util/Colors';

import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DataSource } from '../../../models/SearchResultTypes';
import { ListViewStyles } from '../ListViewStyles';
import { IconComponentProps } from './LinkCell';
import { cssClass } from '../../../../common/styles/CommonStyles';
import { NestedCSSProperties } from 'typestyle/lib/types';

type DatasourceIconType = 'embedded' | 'extract' | 'extract_embedded' | 'live';
const DatasourceIcons: Record<DatasourceIconType, (props: any) => React.ReactSVGElement> = {
  extract_embedded: DatasourceCanExtractEmbeddedIcon,
  embedded: DatasourceCanEmbeddedIcon,
  extract: DatasourceCanExtractIcon,
  live: DatasourceCanBaseIcon,
};

export function DataSourceType(props: IconComponentProps): JSX.Element {
  const data = props.data as DataSource;
  const icon = getIconForDatasourceType(data);
  const altText = contentTypeTitleForIconForRow(data);

  return (
    <div className={ListViewStyles.ContentTypeCellContainer} style={{ width: '18px' }}>
      {icon({ size: 18, color: Colors.Default, alt: altText })}
    </div>
  );

  function getIconForDatasourceType(dataSource: DataSource): (props: any) => React.ReactSVGElement {
    // there are 3 cases need show extract_embedded icon
    // 1) ebmedded ds with extract to file
    // 2) ebmedded ds with extract to published ds with live/extract
    if (dataSource.workbookId && dataSource.hasExtracts) {
      return DatasourceIcons.extract_embedded;
    }

    if (dataSource.workbookId) {
      return DatasourceIcons.embedded;
    }

    return getIconPathforPublished(dataSource.hasExtracts || false);
  }

  function getIconPathforPublished(hasExtracts: boolean): (props: any) => React.ReactSVGElement {
    if (hasExtracts) {
      return DatasourceIcons.extract;
    } else {
      return DatasourceIcons.live;
    }
  }

  function contentTypeTitleForIconForRow(data: DataSource): string {
    if (data.workbookId) {
      return Messages.column_datasource_icon_title_emb_ds({
        LIVE_OR_EXTRACT: data.hasExtracts ? Messages.extract() : Messages.live(),
        UNICODE: String.fromCharCode(8212),
      });
    }
    return Messages.datasource();
  }
}

export const GreyedOutTextStyle: React.CSSProperties = {
  color: '#BFBFBF',
  fontWeight: 'inherit',
};

export namespace HiddenUserStyles {
  export const HiddenUserStyle: React.CSSProperties = {
    ...GreyedOutTextStyle,
  };

  export const HiddenUserClassName: string = cssClass('hidden-user', HiddenUserStyle as NestedCSSProperties);
}
